/**
 * GenEra Health Co. — Theme JavaScript
 * Version: 1.0.0
 * Vanilla JS — no external dependencies
 */

(function () {
  'use strict';

  /* =====================================================
     Utilities
     ===================================================== */
  function qs(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function qsa(selector, scope) {
    return Array.from((scope || document).querySelectorAll(selector));
  }

  function on(el, event, handler, options) {
    if (el) el.addEventListener(event, handler, options);
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return '$' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* =====================================================
     1. Mobile Menu Toggle
     ===================================================== */
  function initMobileMenu() {
    var hamburger = qs('.hamburger-btn');
    var mobileMenu = qs('.mobile-menu');
    var body = document.body;

    if (!hamburger || !mobileMenu) return;

    function openMenu() {
      hamburger.classList.add('is-open');
      mobileMenu.classList.add('is-open');
      body.style.overflow = 'hidden';
      hamburger.setAttribute('aria-expanded', 'true');
    }

    function closeMenu() {
      hamburger.classList.remove('is-open');
      mobileMenu.classList.remove('is-open');
      body.style.overflow = '';
      hamburger.setAttribute('aria-expanded', 'false');
    }

    on(hamburger, 'click', function () {
      if (mobileMenu.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    // Close on escape key
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
        closeMenu();
        hamburger.focus();
      }
    });

    // Close on mobile menu link click
    qsa('.mobile-menu__nav a').forEach(function (link) {
      on(link, 'click', closeMenu);
    });
  }

  /* =====================================================
     2. Sticky Header on Scroll
     ===================================================== */
  function initStickyHeader() {
    var header = qs('.site-header');
    if (!header) return;

    var scrollThreshold = 50;
    var ticking = false;

    function updateHeader() {
      if (window.scrollY > scrollThreshold) {
        header.classList.add('header-scrolled');
      } else {
        header.classList.remove('header-scrolled');
      }
      ticking = false;
    }

    on(window, 'scroll', function () {
      if (!ticking) {
        requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });

    updateHeader();
  }

  /* =====================================================
     3. Cart Count Update
     ===================================================== */
  function updateCartCount() {
    fetch('/cart.json')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        qsa('.cart-count').forEach(function (el) {
          el.textContent = count > 0 ? count : '';
          el.setAttribute('data-count', count);
        });
      })
      .catch(function () {});
  }

  /* =====================================================
     4. Cart Drawer Open/Close
     ===================================================== */
  function initCartDrawer() {
    var drawer = qs('.cart-drawer');
    var overlay = qs('.cart-overlay');

    if (!drawer) return;

    function openCartDrawer() {
      drawer.classList.add('cart-drawer--open');
      if (overlay) overlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
      fetchCartDrawerItems();
    }

    function closeCartDrawer() {
      drawer.classList.remove('cart-drawer--open');
      if (overlay) overlay.classList.remove('is-visible');
      document.body.style.overflow = '';
    }

    // Listen for cart:open event
    on(document, 'cart:open', openCartDrawer);

    // Listen for cart icon clicks
    qsa('[data-cart-trigger]').forEach(function (btn) {
      on(btn, 'click', function (e) {
        e.preventDefault();
        openCartDrawer();
      });
    });

    // Close button inside drawer
    var closeBtn = qs('.cart-drawer__close', drawer);
    on(closeBtn, 'click', closeCartDrawer);

    // Click overlay to close
    on(overlay, 'click', closeCartDrawer);

    // Escape key closes drawer
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('cart-drawer--open')) {
        closeCartDrawer();
      }
    });

    // Quantity & remove delegation inside drawer
    var itemsContainer = qs('.cart-drawer__items', drawer);
    if (itemsContainer) {
      on(itemsContainer, 'click', function (e) {
        var target = e.target;

        // Remove item
        if (target.closest('[data-remove-item]')) {
          var key = target.closest('[data-remove-item]').getAttribute('data-remove-item');
          updateCartItem(key, 0);
        }

        // Decrease quantity
        if (target.closest('[data-qty-decrease]')) {
          var itemEl = target.closest('[data-cart-item]');
          if (!itemEl) return;
          var k = itemEl.getAttribute('data-item-key');
          var currentQty = parseInt(itemEl.getAttribute('data-item-qty'), 10);
          if (currentQty > 1) updateCartItem(k, currentQty - 1);
          else updateCartItem(k, 0);
        }

        // Increase quantity
        if (target.closest('[data-qty-increase]')) {
          var itemEl2 = target.closest('[data-cart-item]');
          if (!itemEl2) return;
          var k2 = itemEl2.getAttribute('data-item-key');
          var currentQty2 = parseInt(itemEl2.getAttribute('data-item-qty'), 10);
          updateCartItem(k2, currentQty2 + 1);
        }
      });
    }
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        fetchCartDrawerItems();
        updateCartCount();
      })
      .catch(function () {});
  }

  function fetchCartDrawerItems() {
    fetch('/cart.json')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        updateCartCount();
      })
      .catch(function () {});
  }

  function renderCartDrawer(cart) {
    var drawer = qs('.cart-drawer');
    if (!drawer) return;

    var itemsContainer = qs('.cart-drawer__items', drawer);
    var subtotalEl = qs('.cart-drawer__subtotal-value', drawer);

    if (!itemsContainer) return;

    if (cart.item_count === 0) {
      itemsContainer.innerHTML =
        '<div class="cart-drawer__empty">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>' +
        '<p>Your cart is empty</p>' +
        '<a href="/collections/all" class="btn btn-primary btn--sm">Start Shopping</a>' +
        '</div>';
    } else {
      var itemsHtml = cart.items.map(function (item) {
        var imageHtml = item.featured_image && item.featured_image.url
          ? '<img src="' + item.featured_image.url + '" alt="' + item.product_title + '" loading="lazy">'
          : '';

        var variantHtml = item.variant_title && item.variant_title !== 'Default Title'
          ? '<div class="cart-item__variant">' + item.variant_title + '</div>'
          : '';

        return '<div class="cart-item" data-cart-item data-item-key="' + item.key + '" data-item-qty="' + item.quantity + '">' +
          '<div class="cart-item__image">' + imageHtml + '</div>' +
          '<div class="cart-item__details">' +
          '<div class="cart-item__title">' + item.product_title + '</div>' +
          variantHtml +
          '<div class="cart-item__controls">' +
          '<div class="cart-item__qty">' +
          '<button data-qty-decrease aria-label="Decrease quantity">−</button>' +
          '<span class="cart-item__qty-value">' + item.quantity + '</span>' +
          '<button data-qty-increase aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<button class="cart-item__remove" data-remove-item="' + item.key + '">Remove</button>' +
          '</div>' +
          '</div>' +
          '<div class="cart-item__price">' + formatMoney(item.line_price) + '</div>' +
          '</div>';
      }).join('');

      itemsContainer.innerHTML = itemsHtml;
    }

    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(cart.total_price);
    }
  }

  /* =====================================================
     5. Add to Cart AJAX
     ===================================================== */
  function initAddToCart() {
    on(document, 'submit', function (e) {
      var form = e.target;
      if (!form.classList.contains('product-form')) return;

      e.preventDefault();

      var submitBtn = qs('[type="submit"]', form);
      var originalText = submitBtn ? submitBtn.textContent : '';

      if (submitBtn) {
        submitBtn.classList.add('btn--loading');
        submitBtn.innerHTML = '<span class="loading-spinner"></span>';
        submitBtn.disabled = true;
      }

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () {
          updateCartCount();
          document.dispatchEvent(new CustomEvent('cart:open'));
        })
        .catch(function (err) {
          var msg = err && err.description ? err.description : 'Unable to add item to cart. Please try again.';
          showError(form, msg);
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.classList.remove('btn--loading');
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }
        });
    });
  }

  function showError(form, message) {
    var existingError = qs('.product-form__error', form.parentNode);
    if (existingError) existingError.remove();

    var errorEl = document.createElement('p');
    errorEl.className = 'product-form__error form-error';
    errorEl.textContent = message;
    form.parentNode.insertBefore(errorEl, form.nextSibling);

    setTimeout(function () {
      if (errorEl.parentNode) errorEl.remove();
    }, 5000);
  }

  /* =====================================================
     6. Product Gallery — Thumbnail Click
     ===================================================== */
  function initProductGallery() {
    var gallery = qs('.product__gallery');
    if (!gallery) return;

    var mainImage = qs('.product__main-image img', gallery);
    var thumbnails = qsa('.product__thumbnail', gallery);

    thumbnails.forEach(function (thumb) {
      on(thumb, 'click', function () {
        var src = thumb.getAttribute('data-src');
        var alt = thumb.getAttribute('data-alt');

        if (mainImage && src) {
          mainImage.src = src;
          if (alt) mainImage.alt = alt;
        }

        thumbnails.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* =====================================================
     7. Sticky Add-to-Cart
     ===================================================== */
  function initStickyATC() {
    var stickyBar = qs('.sticky-atc');
    var addToCartBtn = qs('.product__add-to-cart');

    if (!stickyBar || !addToCartBtn) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          stickyBar.classList.add('is-visible');
        } else {
          stickyBar.classList.remove('is-visible');
        }
      });
    }, { threshold: 0.1 });

    observer.observe(addToCartBtn);

    // Sticky bar submit
    var stickyBtn = qs('[data-sticky-atc-btn]', stickyBar);
    if (stickyBtn) {
      on(stickyBtn, 'click', function () {
        var productForm = qs('.product-form');
        if (productForm) {
          productForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      });
    }
  }

  /* =====================================================
     8. FAQ Accordion
     ===================================================== */
  function initFAQ() {
    qsa('.faq__item').forEach(function (item) {
      var question = qs('.faq__question', item);
      var answer = qs('.faq__answer', item);

      if (!question || !answer) return;

      question.setAttribute('aria-expanded', 'false');

      on(question, 'click', function () {
        var isOpen = item.classList.contains('is-open');

        // Close all other items
        qsa('.faq__item.is-open').forEach(function (openItem) {
          if (openItem !== item) {
            openItem.classList.remove('is-open');
            var q = qs('.faq__question', openItem);
            if (q) q.setAttribute('aria-expanded', 'false');
          }
        });

        if (isOpen) {
          item.classList.remove('is-open');
          question.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('is-open');
          question.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* =====================================================
     9. Collection Filter Toggle
     ===================================================== */
  function initCollectionFilters() {
    var filterBtn = qs('.collection-toolbar__filter-btn');
    var filterSidebar = qs('.filter-sidebar');

    if (!filterBtn || !filterSidebar) return;

    on(filterBtn, 'click', function () {
      filterSidebar.classList.toggle('is-hidden');
      var isHidden = filterSidebar.classList.contains('is-hidden');
      filterBtn.setAttribute('aria-expanded', isHidden ? 'false' : 'true');
      filterBtn.textContent = isHidden ? 'Show Filters' : 'Hide Filters';
    });

    // Sort select redirect
    var sortSelect = qs('.sort-select');
    if (sortSelect) {
      on(sortSelect, 'change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.href = url.toString();
      });
    }
  }

  /* =====================================================
     10. Scroll Reveal (IntersectionObserver)
     ===================================================== */
  function initScrollReveal() {
    var elements = qsa('.reveal');
    if (!elements.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px'
    });

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* =====================================================
     11. Variant Selector (Product Page)
     ===================================================== */
  function initVariantSelector() {
    var variantSelect = qs('.product__variant-select');
    if (!variantSelect) return;

    var productDataEl = qs('[data-product-json]');
    if (!productDataEl) return;

    var productData;
    try {
      productData = JSON.parse(productDataEl.textContent);
    } catch (e) {
      return;
    }

    on(variantSelect, 'change', function () {
      var selectedVariantId = parseInt(variantSelect.value, 10);
      var variant = productData.variants.find(function (v) { return v.id === selectedVariantId; });

      if (!variant) return;

      // Update price display
      var priceEl = qs('.product__price');
      var comparePriceEl = qs('.product__price--compare');

      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
      }

      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }

      // Update hidden variant id input
      var variantInput = qs('input[name="id"]', qs('.product-form'));
      if (variantInput) {
        variantInput.value = selectedVariantId;
      }

      // Update availability
      var addBtn = qs('.product__add-to-cart');
      if (addBtn) {
        if (!variant.available) {
          addBtn.disabled = true;
          addBtn.textContent = 'Sold Out';
        } else {
          addBtn.disabled = false;
          addBtn.textContent = 'Add to Cart';
        }
      }

      // Update URL
      var url = new URL(window.location.href);
      url.searchParams.set('variant', selectedVariantId);
      window.history.replaceState({}, '', url.toString());
    });
  }

  /* =====================================================
     12. Quantity Selector (Product Page)
     ===================================================== */
  function initQuantitySelector() {
    qsa('.quantity-selector').forEach(function (selector) {
      var minusBtn = qs('.quantity-selector__btn--minus', selector);
      var plusBtn = qs('.quantity-selector__btn--plus', selector);
      var input = qs('.quantity-selector__input', selector);

      if (!input) return;

      if (minusBtn) {
        on(minusBtn, 'click', function () {
          var val = parseInt(input.value, 10) || 1;
          if (val > 1) {
            input.value = val - 1;
          }
        });
      }

      if (plusBtn) {
        on(plusBtn, 'click', function () {
          var val = parseInt(input.value, 10) || 1;
          var max = parseInt(input.getAttribute('max'), 10);
          if (!max || val < max) {
            input.value = val + 1;
          }
        });
      }
    });
  }

  /* =====================================================
     13. Cart Page Quantity Updates
     ===================================================== */
  function initCartPage() {
    var cartForm = qs('.cart-page__form');
    if (!cartForm) return;

    on(cartForm, 'click', function (e) {
      var target = e.target;

      // Remove item button
      if (target.closest('.cart-line-item__remove')) {
        e.preventDefault();
        var btn = target.closest('.cart-line-item__remove');
        var key = btn.getAttribute('data-key');
        if (!key) return;

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        })
          .then(function () {
            var row = btn.closest('.cart-line-item');
            if (row) {
              row.style.opacity = '0';
              row.style.transition = 'opacity 0.3s';
              setTimeout(function () { row.remove(); }, 300);
            }
            updateCartCount();
            updateCartPageTotal();
          })
          .catch(function () {});
      }
    });

    on(cartForm, 'change', function (e) {
      var target = e.target;
      if (target.classList.contains('cart-line-item__qty-input')) {
        var key = target.getAttribute('data-key');
        var qty = parseInt(target.value, 10);
        if (!key || isNaN(qty) || qty < 0) return;

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        })
          .then(function (res) { return res.json(); })
          .then(function () {
            updateCartCount();
            updateCartPageTotal();
          })
          .catch(function () {});
      }
    });
  }

  function updateCartPageTotal() {
    fetch('/cart.json')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var totalEl = qs('.cart-summary__total-value');
        if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

        var subtotalEl = qs('.cart-summary__subtotal-value');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      })
      .catch(function () {});
  }

  /* =====================================================
     14. Newsletter Form (Email Signup)
     ===================================================== */
  function initNewsletterForms() {
    qsa('.email-signup__form, .footer-newsletter__form').forEach(function (form) {
      on(form, 'submit', function (e) {
        var input = qs('input[type="email"]', form);
        if (input && !input.value.trim()) {
          e.preventDefault();
          input.focus();
        }
      });
    });
  }

  /* =====================================================
     15. Announcement Bar (allow dismissal)
     ===================================================== */
  function initAnnouncementBar() {
    var bar = qs('.announcement-bar');
    var closeBtn = qs('.announcement-bar__close');

    if (!bar || !closeBtn) return;

    on(closeBtn, 'click', function () {
      bar.style.maxHeight = bar.offsetHeight + 'px';
      requestAnimationFrame(function () {
        bar.style.transition = 'max-height 0.3s ease, opacity 0.3s ease';
        bar.style.maxHeight = '0';
        bar.style.opacity = '0';
        bar.style.overflow = 'hidden';
      });
    });
  }

  /* =====================================================
     16. Smooth scroll for anchor links
     ===================================================== */
  function initSmoothScroll() {
    on(document, 'click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;

      var href = link.getAttribute('href');
      if (!href || href === '#') return;

      var target = qs(href);
      if (!target) return;

      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* =====================================================
     17. Header search toggle
     ===================================================== */
  function initHeaderSearch() {
    var searchBtn = qs('[data-search-trigger]');
    var searchForm = qs('.header-search-form');

    if (!searchBtn || !searchForm) return;

    on(searchBtn, 'click', function () {
      searchForm.classList.toggle('is-active');
      var input = qs('input[type="search"]', searchForm);
      if (searchForm.classList.contains('is-active') && input) {
        setTimeout(function () { input.focus(); }, 100);
      }
    });

    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && searchForm.classList.contains('is-active')) {
        searchForm.classList.remove('is-active');
        searchBtn.focus();
      }
    });
  }

  /* =====================================================
     Init
     ===================================================== */
  function init() {
    initMobileMenu();
    initStickyHeader();
    updateCartCount();
    initCartDrawer();
    initAddToCart();
    initProductGallery();
    initStickyATC();
    initFAQ();
    initCollectionFilters();
    initScrollReveal();
    initVariantSelector();
    initQuantitySelector();
    initCartPage();
    initNewsletterForms();
    initAnnouncementBar();
    initSmoothScroll();
    initHeaderSearch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
